import React from "react";
import { Container, Row, Card, CardBody, Table } from "reactstrap";
import "react-slide-out/lib/index.css";
import * as env from "../../../../env";
import { columnHeader, products } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import MoreActions from "./MoreActions";
import { Link } from "react-router-dom";

class ProductsListing extends React.Component {
  state = {
    title: "Products",
    addTitle: "Add Product",
    isOpen: false,
    results: [],
    filteredResults: [],
    columnHeader: columnHeader,
    filters: [],
    filterValues: {
      type: [],
      concurrent_connection: [],
      locations: [],
    },
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
  };

  getResults() {
    this.setResults(products);

    // let params = userAction.toQueryString({});

    // var url = new URL(`${env.API_URL}admin/subnets?${params}`);

    // fetch( url, {
    //     "method": "GET",
    //   })
    //   .then(response => response.json())
    //   .then((result) => this.setSubnets(result));
  }

  setResults = (results) => {
    this.setState({
      isOpen: false,
      results: results,
      filteredResults: results,
    });

    let filterValues = this.state.filterValues;

    results.map((result) => {
      this.state.columnHeader.map((header) => {
        if (header.type === "list") {
          switch (header.key) {
            default:
              if (!filterValues[header.key].includes(result[header.key])) {
                filterValues[header.key].push(result[header.key]);
              }
          }
        }

        return header;
      });

      return result;
    });
  };

  componentDidMount() {
    this.getResults();
  }

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = { name: event.target.name, value: event.target.value };

    var foundIndex = filters.findIndex((x) => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({ filters });
    this.filterResults();
  };

  filterResults = () => {
    let filteredResults = this.state.results;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== "") {
        switch (element.name) {
          case "id":
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) =>
                String(o[element.name])
                  .toLowerCase()
                  .includes(element.value)
              )
            );
            break;
          case "type":
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) => o[element.name] === element.value)
            );
            break;
          default:
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) =>
                o[element.name].toLowerCase().includes(element.value)
              )
            );
        }
      }
    });

    this.setState({ filteredResults });
  };

  printFilters = () => {
    return (
      <tr>
        {this.state.columnHeader.map((data) =>
          data.filter ? (
            <th key={data.key}> {this.printFilterInput(data)}</th>
          ) : (
            <th></th>
          )
        )}
      </tr>
    );
  };

  printFilterInput = (input) => {
    if (input.type === "text")
      return (
        <input
          name={input.key}
          type="text"
          onChange={this.formChangeHandler}
        ></input>
      );
    else if (input.type === "list" || input.type === "multiple-list")
      return (
        <select name={input.key} type="text" onChange={this.formChangeHandler}>
          <option value="">All</option>
          {this.printOptions(input.key)}
        </select>
      );
  };

  printOptions = (key) => {
    return (
      <React.Fragment>
        {this.state.filterValues[key].map((value) => (
          <option value={value}>{value}</option>
        ))}
      </React.Fragment>
    );
  };

  printRecords = () => {
    let items = this.state.filteredResults.slice(
      this.state.startIndex,
      this.state.endIndex + 1
    );

    return (
      <React.Fragment>
        {items.map((data) => (
          <tr key={data.id}>
            {this.state.columnHeader.map((column) =>
              column.key === "actions" ? (
                <td>
                  <MoreActions
                    onEditClicked={() => this.toggleEdit(data)}
                    item={data}
                  />
                </td>
              ) : column.key === "users" ? (
                <td>
                  <Link
                    to={() => {
                      return this.usersListingUrl(data);
                    }}
                  >
                    {data[column.key]}
                  </Link>
                </td>
              ) : column.key === "concurrent_connection" ? (
                <td> {data[column.key] ? "Yes" : "No"}</td>
              ) : (
                <td>{data[column.key]}</td>
              )
            )}
          </tr>
        ))}
      </React.Fragment>
    );
  };

  usersListingUrl = (product) => {
    return `/proxy/products/users/${product.id}`;
  };

  pagination = () => {
    return this.state.filteredResults.length > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.filteredResults}
          onChangePage={(pagination) => this.setState(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  toggleAddNew = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  toggleEdit = (item) => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  printActions = () => {
    return <React.Fragment></React.Fragment>;
  };

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
                <div className="toolbar-buttons">{this.printActions()}</div>
              </div>
              <Table
                responsive
                hover
                className="table--head-accent table--bordered"
              >
                <thead>
                  <tr>
                    {this.state.columnHeader.map((data) => (
                      <th key={data.key}>{data.name}</th>
                    ))}
                  </tr>
                  {this.printFilters()}
                </thead>
                <tbody>{this.printRecords()}</tbody>
              </Table>
              {this.pagination()}
            </CardBody>
          </Card>
        </Row>
      </Container>
    );
  }
}

export default ProductsListing;
